import { render, staticRenderFns } from "./BlogSidebar.vue?vue&type=template&id=fbf633a0&scoped=true"
import script from "./BlogSidebar.vue?vue&type=script&lang=js"
export * from "./BlogSidebar.vue?vue&type=script&lang=js"
import style0 from "./BlogSidebar.vue?vue&type=style&index=0&id=fbf633a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf633a0",
  null
  
)

export default component.exports